import { Stack } from "@mui/material";
import { useGetDashboardTermsheetListQuery } from "api/api-accounts";
import SkeletonLoad from "components/Common/SkeletonLoad";
import TermsheetToDo from "components/Termsheets/TermsheetToDo";
import React from "react";
import InsurerCommunication from "./InsurerCommunication";
import InsurerStatsOverviewData from "./InsurerStatsOverviewData";

const InsurerStatsDashboard: React.FC = () => {
  const {
    data: termsheetTodos,
    isFetching: isFetchingTermsheetTodos,
    refetch: refetchTermsheetTodos,
  } = useGetDashboardTermsheetListQuery(null);

  return (
    <Stack spacing={4}>
      <InsurerStatsOverviewData />
      {isFetchingTermsheetTodos && (
        <SkeletonLoad bars={5} />
      )}
      {!isFetchingTermsheetTodos &&
        termsheetTodos && (
          <TermsheetToDo
            termsheetTodos={termsheetTodos}
            syncAction={refetchTermsheetTodos}
          />
        )}
      <InsurerCommunication />
    </Stack>
  );
};

export default InsurerStatsDashboard;
